import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase/client';

export interface BOMComponent {
  id: string;
  component_name: string;
  material: string;
  material_id?: string;
  quantity: number;
  unit: string;
}

export function useBOMComponents() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const getBOMComponents = useCallback(async (bomId: string): Promise<BOMComponent[]> => {
    if (!bomId) return [];
    
    setIsLoading(true);
    setError(null);

    try {
      // Fetch BOM components
      const { data, error } = await supabase
        .from('bom_components')
        .select('id, component_name, material, raw_material_id, quantity, unit')
        .eq('bom_id', bomId)
        .order('sequence_order', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (err) {
      console.error('Error fetching BOM components:', err);
      setError(err as Error);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    getBOMComponents,
    isLoading,
    error
  };
}
